import { ICellRendererParams } from 'ag-grid-community';
import React from 'react'
import { IGridDataCellActionButton, IModalObject } from '.';
import { useDispatch } from 'react-redux';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { Dispatch, UnknownAction } from '@reduxjs/toolkit';
import { Button, IconButton } from '@mui/material';
import GenerateIcon from '../GenerateIcon';

interface GridDataActionButtonsProps extends ICellRendererParams<IModalObject> {
    buttons: IGridDataCellActionButton[]
}

interface IGridDataCellActionButtonProps extends IGridDataCellActionButton {
    dispatch: Dispatch<UnknownAction>, 
    navigate: NavigateFunction,
    data: IModalObject,
}

export function GridDataActionButton(props: IGridDataCellActionButtonProps) {

    const { data, color, isIconButton, icon, label, onClick, customButton, dispatch, navigate } = props

    if (!data) return null;

    if (customButton){
        return customButton(data, dispatch, navigate)
    }

    if (isIconButton && icon){
        return <IconButton color={color} onClick={() => onClick(data, dispatch, navigate)}><GenerateIcon icon={icon} /></IconButton>
    }

    return <Button className="admin-button general-button grid-data-action-cell-button" startIcon={icon ? <GenerateIcon icon={icon} /> : <></>} onClick={() => onClick(data, dispatch, navigate)}>{label}</Button>
}

const GridDataActionButtons: React.FC<GridDataActionButtonsProps> = ({ data, buttons }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
  
    if (!data) return null;
  
    return (
        <div className="grid-data-cell-action-buttons">
            <div className="content-of-grid-data-cell-action-buttons">
                {buttons.map((button, index) => <GridDataActionButton key={index} data={data} {...button} dispatch={dispatch} navigate={navigate} />)}
            </div>
        </div>
    )
}

export default GridDataActionButtons;